import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { selectDbnpQueryItems } from '../../../../../../redux/dbnp/selector';
import { dbnp } from '../../../../../../redux/dbnp/action';
import { organizationUnits } from '../../../../../../redux/organizationUnits/action';
import { selectOrganizationUnitsListItems } from '../../../../../../redux/organizationUnits/selector';
import DbnpComponent from '../components/dbnp.component';
import PageLoader from '../../../../../../components/PageLoader';
import { selectOpennetworkDomainsListItems } from '../../../../../../redux/opennetwork-domains/selector';
import storePersist from '../../../../../../redux/storePersist';
import * as R from "ramda"
import { opennetworkDomains } from '../../../../../../redux/opennetwork-domains/action';
import { dbnpRegistries } from '../../../../../../redux/dbnp-registries/action';
import { selectDbnpRegistriesQueryItems } from '../../../../../../redux/dbnp-registries/selector';
import { orgRegistries } from '../../../../../../redux/org-registries/action';
const Dbnp = () => {   
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const dbnpQuery = useSelector(selectDbnpQueryItems)
  const organizationUnitsLists = useSelector(selectOrganizationUnitsListItems)
  const openNetworkDomainNameLists = useSelector(selectOpennetworkDomainsListItems)
    const librariesItems = storePersist?.get("library")?.current;
    const countries =  storePersist.get('countries').current?.items;
    const [ selectedDbnpRegistry, setSelectedDbnpRegistry ] = useState<any>({})
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
const dbnpRegistriesQuery = useSelector(selectDbnpRegistriesQueryItems)
  const [
    selectedDbnp,
    setSelectedDbnp
  ] = useState<any>({})
 

  const fetchRouteById= async ()=>{
    await dispatch(dbnp.query({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbnp/query`,entity:'dbnp',jsonData:{
          
    Records: [
      {
        Id: parmas?.id
      }
    ]
  
}}))
 await dispatch(dbnpRegistries.query({
    url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbnp-registries/query`, 
    entity: 'dbnpRegistries', 
    jsonData: {
        Records: [
            {
              DBNPId: parmas?.id
            }
        ]
    }
}))
  setIsQuery(true)
 }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedDbnp({ ...selectedDbnp, [field]: event });
    setSelectedDbnpRegistry({ ...selectedDbnpRegistry, [field]: event });
  }

  const handleFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedDbnpRegistry({ ...selectedDbnpRegistry, [fields[0]]: value });
}
  useEffect(
    () => {
      dispatch(opennetworkDomains.list({ 
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/opennetwork-domains/list`, 
        entity: 'opennetworkDomains', 
        jsonData: {} 
    }))
.then(() => {
        dispatch(organizationUnits.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`,entity:'organizationUnits',jsonData:{}}))
}).then(()=>{
            if (parmas?.id > 0) {
                fetchRouteById()
                setIsLoading(false)
              }else {
                setIsLoading(false)
              }
           
          })
    },
    []
  )

  const parentDomain = openNetworkDomainNameLists?.result?.items.filter(
    (subDomainData: any) => subDomainData.IsSubDomain === false
)
const subDomains = openNetworkDomainNameLists?.result?.items.filter(
    (subDomainData: any) => subDomainData.IsSubDomain === true
)
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedDbnp(dbnpQuery?.result?.items)
        setSelectedDbnpRegistry(dbnpRegistriesQuery?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    const dbnpPayload = {
          ...selectedDbnp,
          DBNPRegistryDetails: {
            ...selectedDbnpRegistry,
            DBNPId: parmas?.id ||0,  
          },
    };
  
    if (parmas?.id > 0) {
      await dispatch(dbnp.resetAction({ actionType: 'update' }))
      await dispatch(dbnp.update({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbnp`,entity:'dbnp',jsonData:{
          
    Records: [
        selectedDbnp
    ]
 
}}))
  await dispatch(dbnpRegistries.resetAction({ actionType: 'update' }))
  await dispatch(dbnpRegistries.update({
    url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbnp-registries`, 
    entity: 'dbnpRegistries', 
    jsonData: {
        Records: [{
          ...selectedDbnpRegistry,
          DBNPId: parmas?.id , 
        } 
        ]
    }
})).then(() => {
    back()
})
    back()
  

    }else{
      await dispatch(dbnp.resetAction({ actionType: 'create' }))
      await dispatch(dbnp.create({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbnp`,entity:'dbnp',jsonData:{
          
      Records: [
        dbnpPayload
      ]
    
  }})).then(()=>{
    back()
  })
  
    }
   
    
  }
  const handlePopulateOrgRegistry = async () => {
    await dispatch(orgRegistries.resetAction({ actionType: 'create' }))
    await dispatch(orgRegistries.create({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/org-registries/publish`,
      entity: 'orgRegistries',
      jsonData: {
        Context: {},
        Records: [{}]
      }
    })).then(() => {
      back()
    });
  }
const back=()=>{
  navigate('/management/organization/dbn/dbnp')
} 

    return (
    <>
     {isLoading ? <PageLoader /> : 
          <DbnpComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedDbnp={selectedDbnp}
           back={back}
           handleFormSubmit={handleFormSubmit}
           organizationUnits = {organizationUnitsLists?.result?.items}
           handleFormChange={handleFormChange}
           selectedDbnpRegistry={selectedDbnpRegistry}
           opsnumber={librariesItems?.Ops_no}
          domains={parentDomain}
          subDomains={subDomains}
          countries={countries}
          id={parmas?.id}
          handlePopulateOrgRegistry={handlePopulateOrgRegistry}
          /> 
        } 
          </>
    )
    
    }
   
    export default Dbnp;